import { createSlice } from "@reduxjs/toolkit";
import strings from "i18n/en";
import { formTypes } from "utils/Types";

const SLICE = "CustomPlanCreation";

const commonSteps = [strings["custom.plan.creation.step3"]];

export const flowOptions: Record<string, string[]> = {
  first: [strings["custom.plan.creation.step1"], strings["custom.plan.creation.step2"], ...commonSteps],
  second: [strings["custom.plan.creation.step0"], ...commonSteps]
};

const initialState: any = {
  loadingCount: 0,
  flow: flowOptions["first"],
  currentStep: 0,
  totalSteps: flowOptions["first"].length - 1,
  planMode: formTypes.CreatePlan
};

export const CustomPlanCreation = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    reset: () => {
      return { ...initialState };
    },
    setCustomPlanCreationFlow: (state, action) => {
      state.flow = action.payload;
      state.totalSteps = action.payload?.length - 1;
      state.currentStep = 0;
    },
    setPlanMode: (state, action) => {
      state.planMode = action.payload;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    handleNext: (state) => {
      if (state?.flow) {
        if (state.currentStep < state?.flow?.length - 1) {
          state.currentStep = state.currentStep + 1;
        }
      }
    },
    handleBack: (state) => {
      if (state.currentStep > 0) {
        state.currentStep = state.currentStep - 1;
      }
    }
  }
});

export const { reset, handleBack, handleNext, setPlanMode, setCurrentStep, setCustomPlanCreationFlow } =
  CustomPlanCreation.actions;

export default CustomPlanCreation.reducer;
